import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";

import { NUTRITION_FIELDS } from "../DietDiary/DietDiary.constants";

//Constants
const SET_NUTRITION_VALUES = "SET_NUTRITION_VALUES";
const SET_MEAL_TOTAL_CALORIES = "SET_MEAL_TOTAL_CALORIES";
const SET_MEAL_CHARTS_HELPER = "SET_MEAL_CHARTS_HELPER";
const SET_CREATE_CHANGE_REQUEST_SUCCESS = "SET_CREATE_CHANGE_REQUEST_SUCCESS";
const SET_CREATE_CHANGE_REQUEST_ERROR = "SET_CREATE_CHANGE_REQUEST_ERROR";
const SET_NUTRITION_FIELDS = "SET_NUTRITION_FIELDS";
const SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS";
const SET_ORIGINAL_SELECTED_ITEMS = "SET_ORIGINAL_SELECTED_ITEMS";
const SET_MEAL_DATE_TIME = "SET_MEAL_DATE_TIME";
const SET_ORIGINAL_MEAL_DATE_TIME = "SET_ORIGINAL_MEAL_DATE_TIME";
const SET_ABOUT_MEAL = "SET_ABOUT_MEAL";
const SET_DATE_EXISTING_MEALS = "SET_DATE_EXISTING_MEALS";
const SET_UPDATE_REASON_FOR = "SET_UPDATE_REASON_FOR";
const SET_REASON_FOR_DECLINE = "SET_REASON_FOR_DECLINE";
const CHANGE_REQUEST_RESET_STATES = "CHANGE_REQUEST_RESET_STATES";
const SET_PARTICIPANT_TIME_FORMAT = "SET_PARTICIPANT_TIME_FORMAT";
const LOGOUT = "LOGOUT";

//Acessors
const getNutritionalInfo = (state) => state?.nutritionalInfo;
const getCalories = (state) => state?.calories;
const getChartsHelper = (state) => state?.chartsHelper;
const getIsSuccess = (state) => state?.isSuccess;
const getIsError = (state) => state?.isError;
const getNutritionFields = (state) => state?.nutritionFields;
const getSelectedItems = (state) => state?.selectedItems;
const getOriginalSelectedItems = (state) => state?.originalSelectedItems;
const getDateAndTimeValues = (state) => state?.dateAndTimeValues;
const getOriginalDateAndTimeValues = (state) =>
  state?.originalDateAndTimeValues;
const getAboutMeal = (state) => state?.aboutMeal;
const getExistingDayMeals = (state) => state?.existingDayMeals;
const getUpdateReasonFor = (state) => state?.updateReasonFor;
const getReasonForDecline = (state) => state?.reasonForDecline;
const getDailyTargets = (state) => state?.dietDiaryChartsReducer?.dailyTargets;
const getParticipantTimeFormat = (state) => state?.participantTimeFormat;

//Default state
const initialState = {
  nutritionalInfo: [],
  calories: {
    value: "0.0kcal",
  },
  chartsHelper: {
    pieChartSeries: [],
    hpbcImpact: [],
  },
  isSuccess: false,
  isError: false,
  nutritionFields: [],
  selectedItems: [],
  originalSelectedItems: [],
  dateAndTimeValues: {
    isValid: false,
    dateVals: null,
  },
  originalDateAndTimeValues: {
    isValid: false,
    dateVals: null,
  },
  aboutMeal: null,
  existingDayMeals: [],
  updateReasonFor: "",
  reasonForDecline: "",
  participantTimeFormat: null,
};

export const changeRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NUTRITION_VALUES: {
      const { nutritionalInfo } = action;
      return Object.assign({}, state, {
        nutritionalInfo: nutritionalInfo,
      });
    }
    case SET_MEAL_TOTAL_CALORIES: {
      const { calories } = action;
      return Object.assign({}, state, {
        calories: calories,
      });
    }
    case SET_MEAL_CHARTS_HELPER: {
      const { chartsHelper } = action;
      return Object.assign({}, state, {
        chartsHelper: chartsHelper,
      });
    }
    case SET_CREATE_CHANGE_REQUEST_SUCCESS: {
      const { isSuccess } = action;
      return Object.assign({}, state, {
        isSuccess: isSuccess,
      });
    }
    case SET_CREATE_CHANGE_REQUEST_ERROR: {
      const { isError } = action;
      return Object.assign({}, state, {
        isError: isError,
      });
    }
    case SET_NUTRITION_FIELDS: {
      const { nutritionFields } = action;
      return Object.assign({}, state, {
        nutritionFields: nutritionFields,
      });
    }
    case SET_SELECTED_ITEMS: {
      const { selectedItems } = action;
      return Object.assign({}, state, {
        selectedItems: selectedItems,
      });
    }
    case SET_ORIGINAL_SELECTED_ITEMS: {
      const { originalSelectedItems } = action;
      return Object.assign({}, state, {
        originalSelectedItems: originalSelectedItems,
      });
    }
    case SET_MEAL_DATE_TIME: {
      const { dateAndTimeValues } = action;
      return Object.assign({}, state, {
        dateAndTimeValues: dateAndTimeValues,
      });
    }
    case SET_ORIGINAL_MEAL_DATE_TIME: {
      const { originalDateAndTimeValues } = action;
      return Object.assign({}, state, {
        originalDateAndTimeValues: originalDateAndTimeValues,
      });
    }
    case SET_ABOUT_MEAL: {
      const { aboutMeal } = action;
      return Object.assign({}, state, {
        aboutMeal: aboutMeal,
      });
    }
    case SET_DATE_EXISTING_MEALS: {
      const { allMeals } = action;
      return Object.assign({}, state, {
        existingDayMeals: allMeals,
      });
    }
    case SET_UPDATE_REASON_FOR: {
      const { updateReasonFor } = action;
      return Object.assign({}, state, {
        updateReasonFor: updateReasonFor,
      });
    }
    case SET_REASON_FOR_DECLINE: {
      const { reasonForDecline } = action;
      return Object.assign({}, state, {
        reasonForDecline: reasonForDecline,
      });
    }
    case CHANGE_REQUEST_RESET_STATES: {
      return Object.assign({}, initialState, {
        nutritionFields: state.nutritionFields,
      });
    }
    case SET_PARTICIPANT_TIME_FORMAT: {
      const { participantTimeFormat } = action;

      return Object.assign({}, state, {
        participantTimeFormat: participantTimeFormat,
      });
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

//Mutators
export const resetStates = () => (dispatch) => {
  return dispatch({
    type: CHANGE_REQUEST_RESET_STATES,
  });
};

export const setNutritionalInfo = (newValues) => (dispatch) => {
  return dispatch({
    type: SET_NUTRITION_VALUES,
    nutritionalInfo: newValues,
  });
};

export const setSelectedItems = (items) => (dispatch) => {
  return dispatch({
    type: SET_SELECTED_ITEMS,
    selectedItems: items,
  });
};

export const setOriginalSelectedItems = (items) => (dispatch, getState) => {
  return dispatch({
    type: SET_ORIGINAL_SELECTED_ITEMS,
    originalSelectedItems: items,
  });
};

export const setCalories = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_MEAL_TOTAL_CALORIES,
    calories: newValue,
  });
};

export const setChartsHelper = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_MEAL_CHARTS_HELPER,
    chartsHelper: newValue,
  });
};

export const setIsSuccess = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_CREATE_CHANGE_REQUEST_SUCCESS,
    isSuccess: newValue,
  });
};

export const setIsError = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_CREATE_CHANGE_REQUEST_ERROR,
    isError: newValue,
  });
};

export const setDateAndTimeValues = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_MEAL_DATE_TIME,
    dateAndTimeValues: newValue,
  });
};

export const setOriginalDateAndTimeValues =
  (newValue) => (dispatch, getState) => {
    return dispatch({
      type: SET_ORIGINAL_MEAL_DATE_TIME,
      originalDateAndTimeValues: newValue,
    });
  };

export const setAboutMeal = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_ABOUT_MEAL,
    aboutMeal: newValue,
  });
};

export const setUpdateReasonFor = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_UPDATE_REASON_FOR,
    updateReasonFor: newValue,
  });
};

export const setReasonForDecline = (newValue) => (dispatch, getState) => {
  return dispatch({
    type: SET_REASON_FOR_DECLINE,
    reasonForDecline: newValue,
  });
};

const fetchNutritionFields = () => (dispatch, getState) => {
  dispatch({ type: SET_NUTRITION_FIELDS, nutritionFields: NUTRITION_FIELDS });
};

const createChangeRequest = (formData) => async (dispatch, getState) => {
  return axios
    .post(`/api/diet/changerequest`, formData)
    .then(() => {
      return Promise.resolve(`Your request has been submitted`);
    })
    .catch((error) => {
      const defaultMessage = error.response?.data
        ? error.response.data
        : "There was an error while trying to create the change request!";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

const approveChangeRequest =
  (changeRequestId) => async (dispatch, getState) => {
    const body = {
      mealChangeRequestID: changeRequestId,
      approve: true,
    };

    return axios
      .put(`/api/diet/changerequest`, body)
      .then(() => {
        return Promise.resolve(`Approved Request`);
      })
      .catch((error) => {
        const defaultMessage = error.response?.data
          ? error.response.data
          : "There was an error while trying to approve the change request!";

        return handleHttpErrors(error.request?.status, {
          default: defaultMessage,
        });
      });
  };

const declineChangeRequest =
  (changeRequestId, reasonForDecline) => async (dispatch, getState) => {
    const body = {
      mealChangeRequestID: changeRequestId,
      approve: false,
      reasonForDecline: reasonForDecline,
    };

    return axios
      .put(`/api/diet/changerequest`, body)
      .then(() => {
        return Promise.resolve(`Declined Request`);
      })
      .catch((error) => {
        const defaultMessage = error.response?.data
          ? error.response.data
          : "There was an error while trying to decline the change request!";

        return handleHttpErrors(error.request?.status, {
          default: defaultMessage,
        });
      });
  };

const fetchParticipantTimeFormat = (participantId) => async (dispatch) => {
  const params = {
    participantId,
  };

  return axios
    .get(`/api/participant/info`, { params })
    .then(({ data }) => {
      dispatch({
        type: SET_PARTICIPANT_TIME_FORMAT,
        participantTimeFormat: data.timeFormat,
      });
    })
    .catch(() => {
      dispatch({
        type: SET_PARTICIPANT_TIME_FORMAT,
        participantTimeFormat: null,
      });
    });
};

export const mapStateToProps = (state) => {
  return {
    nutritionalInfo: getNutritionalInfo(state),
    calories: getCalories(state),
    chartsHelper: getChartsHelper(state),
    isSuccess: getIsSuccess(state),
    isError: getIsError(state),
    nutritionFields: getNutritionFields(state),
    selectedItems: getSelectedItems(state),
    originalSelectedItems: getOriginalSelectedItems(state),
    dateAndTimeValues: getDateAndTimeValues(state),
    originalDateAndTimeValues: getOriginalDateAndTimeValues(state),
    aboutMeal: getAboutMeal(state),
    existingDayMeals: getExistingDayMeals(state),
    updateReasonFor: getUpdateReasonFor(state),
    reasonForDecline: getReasonForDecline(state),
    dailyTargets: getDailyTargets(state),
    participantTimeFormat: getParticipantTimeFormat(state),
  };
};

export const mapDispatchToProps = {
  setNutritionalInfo,
  setSelectedItems,
  setOriginalSelectedItems,
  setCalories,
  setChartsHelper,
  setIsSuccess,
  setIsError,
  setDateAndTimeValues,
  setOriginalDateAndTimeValues,
  setAboutMeal,
  setUpdateReasonFor,
  setReasonForDecline,
  createChangeRequest,
  fetchNutritionFields,
  resetStates,
  approveChangeRequest,
  declineChangeRequest,
  fetchParticipantTimeFormat,
};
